const getUrlName = (name) => {
  return name.replace(/_/gm, '-')
}

export default getUrlName
